module.exports = __webpack_public_path__ + "img/chinesecompany24.63f74c4b.png";